import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Divider, IconButton,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {
    useAddEmployeesToAttestationMutation,
    useGetAttestationDetailsQuery,
    useGetNextAttestationNumberQuery,
    usePostCreateAttestationMutation, usePostEditAttestationMutation, useRemoveEmployeesFromAttestationMutation
} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {useListEmployeesQuery} from "../store/employee/employeeApi";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import copyObject from "../utils/copyObject";

export default function EditAttestationPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [startDate, setStartDate] = useState(formatDate(new Date()));
    const [endDate, setEndDate] = useState(formatDate(new Date()));
    const {data} = useGetAttestationDetailsQuery({attestationId: id});
    const [editAttestation] = usePostEditAttestationMutation();
    const isAdmin = localStorage.getItem('roles')?.split(',').includes('AttNewAdmin');
    const {data: chairsWithEmployees} = useListEmployeesQuery();
    const [employeeSelectionModeEnabled, setEmployeeSelectionModeEnabled] = useState(false);
    const [selectedChair, setSelectedChair] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [newEmployees, setNewEmployees] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [employeesToRemove, setEmployeesToRemove] = useState([]);
    const [existingEmployees, setExistingEmployees] = useState([]);
    const [addEmployeeRequest] = useAddEmployeesToAttestationMutation();
    const [removeEmployeeRequest] = useRemoveEmployeesFromAttestationMutation();

    useEffect(() => {
        if (data === null || data === undefined)
            return;

        if (!data.success) {
            data.errors.map((e) => {
                return alert(e);
            })
        } else {
            setStartDate(formatDate(new Date(data.data.startDate)));
            setEndDate(formatDate(new Date(data.data.endDate)));
            setExistingEmployees(copyObject(data.data.employees));
        }
    }, [data])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }
    
    async function saveEmployees() {
        await removeEmployees();
        await saveNewEmployees();
        navigate('/facultyattestations');
    }
    
    async function saveNewEmployees() {
        await addEmployeeRequest({data: {
                attestationId: id,
                employeeIds: newEmployees.map((item) => item.employeeId)
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                console.log(fulfilled)
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
        });
    }
    
    async function removeEmployees() {
        await removeEmployeeRequest({data: {
                attestationId: id,
                employeeIds: employeesToRemove
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                console.log(fulfilled)
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
        });
    }

    const handleSave = async () => {
        setIsSaving(true);

        await editAttestation({data: {
                attestationId: id,
                startDate,
                endDate,
                courseId: data.courseId,
                attestationNumber: data.attestationNumber
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                if (isAdmin) {
                    saveEmployees();
                }
                else
                    navigate('/facultyattestations');
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        });
    };

    function applyVisualChanges() {
        setRefresh(!refresh);
    }
    
    function removeNewEmployee(employee) {
        newEmployees.splice(newEmployees.indexOf(employee), 1)
        applyVisualChanges();
    }
    
    function removeExistingEmployee(employee) {
        employeesToRemove.push(employee.employeeId);
        existingEmployees.splice(existingEmployees.indexOf(employee), 1);
        applyVisualChanges();
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Редактировать аттестацию`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Редактировать аттестацию
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography><strong>Номер аттестации:</strong> {data?.data?.attestationNumber}</Typography>

                                <Stack direction="row" spacing={2}>
                                    <Typography alignSelf="center">
                                        <strong>Дата начала аттестации</strong>
                                    </Typography>
                                    <TextField type="date"
                                               value={startDate}
                                               onChange={(event) => {setStartDate((event.target.value))}}/>
                                </Stack>

                                <Stack direction="row" spacing={2}>
                                    <Typography alignSelf="center">
                                        <strong>Дата окончания аттестации</strong>
                                    </Typography>
                                    <TextField type="date"
                                               value={endDate}
                                               onChange={(event) => {setEndDate((event.target.value))}}/>
                                </Stack>

                                {isAdmin
                                ? <>
                                        <Divider />
                                        <Stack spacing={2}>
                                            <Typography fontWeight="bold"
                                                        fontSize={'medium'}>Администрирование</Typography>
                                            
                                            <Typography>Преподаватели: <IconButton size={'small'} color="primary" onClick={() => {setEmployeeSelectionModeEnabled(!employeeSelectionModeEnabled)}}><AddIcon /></IconButton></Typography>

                                            {employeeSelectionModeEnabled
                                                ? <>
                                                    <Typography fontSize={'small'}>Выбрать преподавателя</Typography>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <TextField label={'Кафедра'}
                                                                   fullWidth
                                                                   select
                                                                   onChange={(event) => {setSelectedChair(copyObject(event.target.value))}}
                                                                   size={'small'}>
                                                            {chairsWithEmployees?.data.map((item) => {
                                                                return <MenuItem value={item} key={item.chairId}>{item.chairName}</MenuItem>
                                                            })}
                                                        </TextField>

                                                        <TextField label={'Преподаватель'}
                                                                   select
                                                                   value={selectedEmployee}
                                                                   onChange={(event) => {setSelectedEmployee(event.target.value)}}
                                                                   fullWidth
                                                                   size={'small'}>
                                                            {selectedChair?.employees.sort((a, b) => a.lastName > b.lastName ? 1 : -1).map((item) => {
                                                                return <MenuItem value={item} key={item.employeeId}>{item.lastName} {item.firstName} {item.middleName}</MenuItem>
                                                            })}
                                                        </TextField>
                                                        
                                                        <Button size={'small'}
                                                                onClick={() => { newEmployees.push(copyObject(selectedEmployee)); setSelectedEmployee(null); }}
                                                                disabled={!selectedEmployee}>Добавить</Button>
                                                    </Stack>

                                                    {newEmployees?.length > 0
                                                    ? <Typography fontSize={'small'}>Новые преподаватели</Typography>
                                                    : <></>}
                                                    <ol>
                                                        {newEmployees?.map((item) => {
                                                            return <li>
                                                                <Stack direction="row" spacing={1} alignItems="center">
                                                                    <Typography fontSize={'small'}>{item.lastName} {item.firstName} {item.middleName}</Typography>
                                                                    <IconButton size={'small'}
                                                                                onClick={() => {removeNewEmployee(item)}}
                                                                                color="error"><DeleteIcon /></IconButton>
                                                                </Stack>
                                                            </li>
                                                        })}
                                                    </ol>
                                                </>
                                                : <></>}

                                            <Typography fontSize={'small'}>Ранее зафиксированные преподаватели</Typography>
                                            <ol>
                                                {existingEmployees?.sort((l,r) => l.fullName > r.fullName ? 1 : -1).map((item) => {
                                                   return <li>
                                                       <Stack direction="row" spacing={1} alignItems="center">
                                                           <Typography fontSize={'small'}>{item.fullName}</Typography>
                                                           <IconButton size={'small'} 
                                                                       onClick={() => {removeExistingEmployee(item)}}
                                                                       color="error"><DeleteIcon /></IconButton>
                                                       </Stack>
                                                   </li> 
                                                })}
                                            </ol>
                                        </Stack>    
                                </>
                                : <></>}

                                <Box height={10}/>

                                <Stack justifyContent="space-between">
                                    {
                                        !isSaving
                                            ? <Button variant="contained"
                                                      disabled={data === null || data === undefined}
                                                      onClick={handleSave}>Сохранить</Button>
                                            : <CircularProgress/>
                                    }
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}